import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import DeleteModal from "components/modal/DeleteModal";
import ViewModal from "components/modal/ViewPartialPayment";
import EditDeleteButton from "components/table/EditDeleteButton";

import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";

import RemarkModal from "components/modal/RemarkModal";

// internal imports

const NotificationTable = ({
  partialpayment,
  perpage,
  currentPage,
}) => {
  const { title, serviceId, serviceBlock, handleModalOpen, handleUpdate } =
    useToggleDrawer();
    const adminInfo = localStorage.getItem("adminInfo")
  ? JSON.parse(localStorage.getItem("adminInfo"))
  : null;
const id_employee = adminInfo?.id ? adminInfo.id : 0;
const payload = {"status": 2,"receiver": id_employee}
  return (
    <>
      <RemarkModal
        id_data={serviceId}
        block_data={serviceBlock}
        title_data={title}
      ></RemarkModal>
      <DeleteModal id={serviceId} 
       body={payload}
      title={title} />
      <ViewModal id={serviceId} title={title} data={partialpayment} />


      <TableBody>
        {partialpayment?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell>
              <span className="font-semibold uppercase text-xs">
                {(currentPage - 1) * perpage + index + 1}
              </span>
            </TableCell>
            <TableCell>
              <span className="text-sm">{data.message}</span>
              <span className="text-sm flex justify-end text-right">{data.sent_time}</span>
            </TableCell>


            <TableCell>
              <div className="flex justify-end text-right">
                <div className="p-2 cursor-pointer text-gray-400 hover:text-green-600">
                 
                </div>
               
                <EditDeleteButton
                  title={data.name}
                  id={data.id}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideDelete={false}
                  hideEdit={true}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default NotificationTable;
